export { PLUGIN_KEY, PLUGIN_PRIORITY, Comments } from "./comments.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/comments/index.mjs
// module id = 1286
// module chunks = 1